export const EXERCISE_ENTITY_UPDATED = 'EXERCISE_ENTITY_UPDATED';
export const AI_COACH_CONTENT_FETCH_STARTED = 'AI_COACH_CONTENT_FETCH_STARTED';
export const AI_COACH_CONTENT_FETCH_ENDED = 'AI_COACH_CONTENT_FETCH_ENDED';
export const COURSE_FETCH_STARTED = 'COURSE_FETCH_STARTED';
export const COURSE_FETCH_ENDED = 'COURSE_FETCH_ENDED';